import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconTag } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTagIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.text.lighter};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
`;

export const StyledIconTag = styled(IconTag)`
  background-color: ${({ theme }) => theme.colors.purple.lighter};
`;

export const StyledAnchor = styled.a`
  text-decoration: none;
`;
